<template>
  <div class="content" ref="content">
    <canvas id="myCanvas" :width="canvasW" :height="canvasH"></canvas>
    <canvas id="midCanvas" :width="canvasW" :height="canvasH"></canvas>
    <canvas id="dhCanvas" :width="canvasW" :height="canvasH"></canvas>
  </div>
</template>

<script>
import { fabric } from "fabric";
import websockMix from "../../utils/websockMix";
import canvasMixRe from "../../utils/canvasMixRe";
import Cookies from "js-cookie";
import { createSocket,sendWSPush } from "../../utils/websocket";
import {
  changeUnRoadPointer,
} from "../../utils/commons";
export default {
  name: "app",
  mixins: [websockMix, canvasMixRe],
  props: ['roadInfoHome','infoTypeItemNumSet','workIdData'],
  data() {
    return {
      canvasW: 950,
      canvasH: 825,
      canvas: "",
      midCanvasm: "",
      getChangeObj: '',
      
    };
  },
  computed: {},
  created() {},
  watch: {
    roadInfoHome: {
      handler(newV) {
          console.log(newV)
            let changeObj = changeUnRoadPointer(
                950,
                825,
                newV.data.content.dataMap
            );
            this.getChangeObj = changeObj[0];
            this.canvas.clear()
            this.setUnRoad(this.canvas, this.getChangeObj,'xc');
      },
      deep: true,
      immediate: true,
    },
    infoTypeItemNumSet:{
      handler(newV) {
        console.log(newV)
        
        
        this.drawImageMid()
        
      },
      deep: true,
      immediate: true,
    },
    workIdData:{
      handler(newV) {
        let that = this
        console.log(newV)
        let tokenValue = Cookies.get("token");
        let setStr =
          "/GetWorkStatus?token=" + tokenValue + "&workId=" + newV;
        let canvasM = document.getElementById('midCanvas'); //画布对象
        let contextM = canvasM.getContext('2d');//画布显示二维图片
        sendWSPush(setStr, function (res) {
          console.log(that.imgX)
          that.drawByPageZF(res,contextM);
        });
        
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // console.log(this.$refs.content)
    // this.canvasW = this.$refs.content.offsetWidth
    // this.canvasH = this.$refs.content.offsetHeight
    // console.log(this.canvasW)
    // console.log(this.canvasH)
    console.log(this.workId,'workId')
    createSocket("wss://" + localStorage.getItem("webSocketUrl") + "/ws");
    // setTimeout(() => {
      this.canvas = new fabric.Canvas("dhCanvas", {
        perPixelTargetFind: true,
      });
      this.midCanvas = new fabric.Canvas("midCanvas", {
        // perPixelTargetFind: true,
      });
      
      this.initCanvasMid(this.canvas);
      
    // }, 2000);
    
  },
  methods: {},
  components: {},
};
</script>
<style lang="scss">
.canvas-container {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
}
</style>
<style lang="scss" scoped="">
.content {
  height: 825px;
  width: 950px;
  position: relative;
}
#midCanvasm {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
}
#dhCanvasm {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10001;
}
</style>